/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(Vuex, VueAxios, axios);

export const cancelOrderline = (context: any, requestData: any) => {
  const url: string = '/-/trade/api/order.line.cancel';

  const data: any = {
    id: requestData.id,
    date: requestData.data.date,
    comment: requestData.data.comment,
  };

  return axios.post(url, data);
};

export const cancelAllOrderlines = (context: any, requestData: any) => {
  const url: string = '/-/trade/api/order.lines.cancel.all';

  const data: any = {
    transactionId: requestData.id,
    date: requestData.data.date,
    comment: requestData.data.comment,
  };

  return axios.post(url, data);
};

export const addComment = (context: any, requestData: any) => {
  const url: string = '/-/trade/api/order.line.comment.create';

  const data: any = {
    orderLineId: requestData.id,
    comment: requestData.data.comment,
  };

  return axios.post(url, data);
};